import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DestructorComponent } from 'src/app/components/destructor/destructor.component';
import { GlobalStateService } from 'src/app/services/global/global-state.service';
import { SettingService } from 'src/app/services/setting/setting.service';
import { GeneralService } from 'src/app/services/general/general.service';
declare var Swal: any;

@Component({
  selector: 'app-news-letter-settings',
  templateUrl: './news-letter-settings.component.html',
  styleUrls: ['./news-letter-settings.component.scss']
})
export class NewsLetterSettingsComponent extends DestructorComponent implements OnInit {

  newsLetterSettingsForm: FormGroup;
  isLoading: boolean = false;
  isUploading: boolean = false;
  settingId: string = '';
  companyLogoUrl: string = '';
  maxBottomTextLength: number = 500;

  constructor(
    private _settingService: SettingService,
    private _globalStateService: GlobalStateService,
    private _generalService: GeneralService,
    private fb: FormBuilder
  ) {
    super();
    this.initializeForm();
  }

  ngOnInit(): void {
    this.getData();
  }

  initializeForm(): void {
    this.newsLetterSettingsForm = this.fb.group({
      company_logo: [''],
      bottom_text: ['']
    });
  }

  getData(): void {
    this.subscriptions.push(
      this._globalStateService.GetSetting().subscribe((res: any) => {
        if (res) {
          this.settingId = res._id;

          // Check if news_letter_settings exists
          if (res.news_letter_settings) {
            this.companyLogoUrl = res.news_letter_settings.company_logo || '';
            this.newsLetterSettingsForm.patchValue({
              company_logo: res.news_letter_settings.company_logo || '',
              bottom_text: res.news_letter_settings.bottom_text || ''
            });
          }
        }
      })
    );
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.uploadFile(file);
    }
  }

  uploadFile(file: File): void {
    this.isUploading = true;
    this._generalService.uploadFileByContent({ "contentType": file.type }).subscribe({
      next: (res) => {
        const fileUrl = res.data.url;
        const formData = this._generalService.convertKeysToFormdata(res.data.result.fields, file);

        this._generalService.sendFileToS3(res.data.result.url, formData).subscribe({
          next: () => {
            this.isUploading = false;
            this.companyLogoUrl = fileUrl;
            this.newsLetterSettingsForm.patchValue({ company_logo: fileUrl });
          },
          error: (error) => {
            this.isUploading = false;
            console.error('Error uploading file to S3:', error);
            Swal.fire({
              text: "Error uploading file. Please try again.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Ok, got it!",
              customClass: {
                confirmButton: "btn btn-primary"
              }
            });
          }
        });
      },
      error: (error) => {
        this.isUploading = false;
        console.error('Error getting presigned URL:', error);
        Swal.fire({
          text: "Error uploading file. Please try again.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Ok, got it!",
          customClass: {
            confirmButton: "btn btn-primary"
          }
        });
      }
    });
  }

  removeLogo(): void {
    this.companyLogoUrl = '';
    this.newsLetterSettingsForm.patchValue({ company_logo: '' });
  }

  onSubmit(): void {
    this.isLoading = true;

    const formData = this.newsLetterSettingsForm.getRawValue();

    const submitData = {
      news_letter_settings: {
        company_logo: formData.company_logo,
        bottom_text: formData.bottom_text
      }
    };

    console.log('Submitting news letter settings:', submitData);

    this.subscriptions.push(
      this._settingService.UpdateData(this.settingId, submitData).subscribe({
        next: (response: any) => {
          this.isLoading = false;
          console.log('News letter settings updated successfully:', response);
          this._globalStateService.SetSetting();

          Swal.fire({
            text: "News letter settings have been successfully updated!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary"
            }
          });
        },
        error: (error: any) => {
          this.isLoading = false;
          console.error('Error updating news letter settings:', error);

          Swal.fire({
            text: "Sorry, looks like there are some errors detected, please try again.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary"
            }
          });
        }
      })
    );
  }

  get bottomTextLength(): number {
    return this.newsLetterSettingsForm.get('bottom_text')?.value?.length || 0;
  }

  openLogoInNewTab(): void {
    if (this.companyLogoUrl) {
      window.open(this.companyLogoUrl, '_blank');
    }
  }
}
